// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__qwff7","slider":"Switch_slider__rkblk"};